import { create } from 'zustand'
import type { Me } from '../api/types'

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated'

interface SessionState {
  me: Me | null
  authStatus: AuthStatus
  /** True once GET /api/me succeeded in this page session (not just loaded from cache). */
  verified: boolean
  setMe: (me: Me, verified?: boolean) => void
  setUnauthenticated: () => void
  reset: () => void
}

export const useSession = create<SessionState>((set) => ({
  me: null,
  authStatus: 'loading',
  verified: false,
  setMe: (me, verified = true) => set((s) => ({ me, authStatus: 'authenticated', verified: verified || s.verified })),
  // Drops the identity so the sign-in screen shows; cached Dexie data stays for the same user.
  setUnauthenticated: () => set({ me: null, authStatus: 'unauthenticated', verified: false }),
  reset: () => set({ me: null, authStatus: 'unauthenticated', verified: false }),
}))

export function currentMeId(): string | null {
  return useSession.getState().me?.id ?? null
}

export function isAdminRole(me: Me | null): boolean {
  return me?.role === 'admin' || me?.role === 'sysadmin'
}
